import React, { useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import {
  GridList,
  Typography,
  GridListTile,
  withStyles,
} from '@material-ui/core'

import { ErrorText } from './Text'


const styles = {
  images: {
    width: '100%',
    height: '100%',
    textAlign: 'center',
    position: 'relative',
    filter: 'grayscale(1)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    border: '1px solid transparent',
    transition: 'filter .25s ease-in-out, border .25s ease-in-out',
  },
  inset: {
    top: 0,
    right: 0,
    bottom: 0,
    opacity: 0,
    width: 20,
    height: 25,
    color: 'white',
    lineHeight: '25px',
    textAlign: 'center',
    position: 'absolute',
    background: '#27ae60',
    transition: 'opacity .25s ease-in-out',
  },
  img: {
    height: '100%',
    maxWidth: '100%',
  },
  enabled: {
    filter: 'none',
    borderColor: '#27ae60',

    '& > *': {
      opacity: 1,
    },
  },
  tile: {
    cursor: 'pointer',
  },
}


const BookSelection = ({
  cols,
  name,
  value,
  folios,
  classes,
  onChange,
  className,
  cellHeight,
}) => {
  const hasFolios = !folios || (Array.isArray(folios) && !folios.length)
  const handleToggleFolio = folioId => () => {
    if (value.includes(folioId)) {
      return onChange({ target: { name, value: value.filter(s => s !== folioId) } })
    }

    return onChange({ target: { name, value: value.concat(folioId) } })
  }

  return (
    <div className={className}>
      <Typography>Click on picture to add it into the book</Typography>
      {hasFolios && <ErrorText>There is no pictures in this profile.</ErrorText>}

      <GridList cols={cols} cellHeight={cellHeight} className="mt3">
        {folios.map((folio) => {
          const position = value.findIndex(x => x === folio.objectID) + 1
          const isInclude = position > 0

          return (
            <GridListTile className={classes.tile} key={folio.objectID} cols={1}>
              {/*
                <div
                  onClick={handleToggleFolio(folio.objectID)}
                  className={classNames(classes.images, { [classes.enabled]: isInclude })}
                  style={{ backgroundImage: `url(${folio.thumbnail || folio.picture})` }}
                >
                  <div className={classes.inset}>{position}</div>
                </div>
              */}
              <div
                onClick={handleToggleFolio(folio.objectID)}
                className={classNames(classes.images, { [classes.enabled]: isInclude })}
              >
                <img src={folio.thumbnail || folio.picture} className={classes.img} />
                <div className={classes.inset}>{position}</div>
              </div>
            </GridListTile>
          )
        })}
      </GridList>

      <br />
      <Typography>Tips: for better result in Chrome, remember to disable automatic margins in the printing options.</Typography>
      <Typography>Tips 2: The first image should be in a portrait format to fit with the title page.</Typography>
    </div>
  )
}


BookSelection.defaultProps = {
  cols: 3,
  value: [],
  folios: [],
  cellHeight: 160,
  onChange: () => {},
}


BookSelection.propTypes = {
  cols: PropTypes.number,
  name: PropTypes.string,
  onChange: PropTypes.func,
  className: PropTypes.string,
  cellHeight: PropTypes.number,
  classes: PropTypes.object.isRequired,
  value: PropTypes.arrayOf(PropTypes.string),
  folios: PropTypes.arrayOf(PropTypes.object),
}


export default withStyles(styles)(BookSelection)
